import React, { useState } from "react";
import "../styles/AnnouncementsPage.css";

// Announcements images
import announcement1 from "../assets/Announcements/A1.jpg";
import announcement2 from "../assets/Announcements/A2.jpg";
import announcement3 from "../assets/Announcements/A3.jpg";
import announcement4 from "../assets/Announcements/A4.jpg";
import announcement5 from "../assets/Announcements/A5.jpg";
import announcement6 from "../assets/Announcements/A6.jpg";
import announcement7 from "../assets/Announcements/A7.jpg";
import announcement8 from "../assets/Announcements/A8.jpg";
import announcement9 from "../assets/Announcements/A9.jpg";
import announcement10 from "../assets/Announcements/A10.jpg";
import announcement11 from "../assets/Announcements/A11.jpg";
import announcement12 from "../assets/Announcements/A12.jpg";
import announcement13 from "../assets/Announcements/A13.jpg";

// Modal Component
const AnnouncementModal = ({ announcement, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="announcement-modal-overlay" onClick={onClose}>
      <div className="announcement-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="announcement-modal-close" onClick={onClose}>×</button>
        
        <div className="announcement-modal-header">
          <div className="announcement-modal-badge">
            <span className="announcement-modal-category">{announcement.category}</span>
            <span className="announcement-modal-date">{announcement.date}</span>
            <span className="announcement-modal-readtime">{announcement.readTime}</span>
          </div>
          <h2 className="announcement-modal-title">{announcement.title}</h2>
        </div>
        
        <div className="announcement-modal-image">
          <img src={announcement.image} alt={announcement.title} />
        </div>
        
        <div className="announcement-modal-body">
          <p className="announcement-modal-description">{announcement.description}</p>
          
          <div className="announcement-modal-details">
            <div className="announcement-modal-detail">
              <span className="announcement-modal-detail-label">Date:</span>
              <span className="announcement-modal-detail-value">{announcement.date}</span>
            </div>
            <div className="announcement-modal-detail">
              <span className="announcement-modal-detail-label">Category:</span>
              <span className="announcement-modal-detail-value">{announcement.category}</span>
            </div>
            <div className="announcement-modal-detail">
              <span className="announcement-modal-detail-label">Reading Time:</span>
              <span className="announcement-modal-detail-value">{announcement.readTime}</span>
            </div>
          </div>
        </div>
        
        <div className="announcement-modal-footer">
          <button className="announcement-modal-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// Announcements data
const announcementsData = [
  {
    id: 1,
    category: "Event",
    title: "Announcing the nomination opportunities for membership in the Board of Directors of Adam Holding Union.",
    description: "On February 22, 2025, the founding body of Adam Holding Union announced the opening of nominations for membership in the Board of Directors of Adam Holding Union. This significant opportunity allows qualified individuals to contribute to the strategic direction and governance of our organization. The nomination process will be transparent and merit-based, ensuring that the best candidates are selected to lead Adam Holding Union into the future.",
    date: "Feb 22, 2025",
    image: announcement1,
    readTime: "2 min read"
  },
  {
    id: 2,
    category: "Event",
    title: "Adam Charity Foundation Iftar",
    description: "Adam Charity Foundation participates in the Iftar project in Mali, Africa. This initiative aims to provide nutritious meals to families in need during the holy month of Ramadan. Our team worked closely with local communities to ensure that the Iftar meals reached those who needed them most, fostering a spirit of giving and community support.",
    date: "Mar 3, 2025",
    image: announcement2,
    readTime: "1 min read"
  },
  {
    id: 3,
    category: "Event",
    title: "Adam Holding Union 2025 Annual Meeting",
    description: "On January 26, 2023, the founding body of Adam Holding Union met with Adam representatives and partners from Africa. The meeting was held in Istanbul and focused on strategic planning, reviewing the previous year's achievements, and setting goals for 2025. Key discussions included expansion plans, new partnerships, and community development initiatives across the African continent.",
    date: "Jan 26, 2025",
    image: announcement3,
    readTime: "2 min read"
  },
  {
    id: 4,
    category: "Event",
    title: "A warm welcome for His Majesty the King of Papango in Istanbul",
    description: "On June 19, 2024, the Chairman of the Board of Directors of Adam Holding Union receives His Majesty King Babongo (Member of the Board of Directors of Adam Holding Union) in Istanbul during His Majesty's visit to Turkey to strengthen trade and economic relations with Turkish and Cameroonian businessmen and investors. This historic meeting marked a significant step in fostering international cooperation and cultural exchange between the two nations.",
    date: "Jun 19, 2024",
    image: announcement4,
    readTime: "3 min read"
  },
  {
    id: 5,
    category: "Event",
    title: "Cameroon Cultural Heritage: Voices of Babungo Leader at the Jacques Chirac Museum",
    description: "Talking today 03/04/2022 in the Jacques Chirac Museum Quai Branly, Paris France on behalf of the delegation of Traditional Rulers from Cameroon on the occasion of the opening ceremony of Exposition of the Cameroonian cultural heritage. This event showcased the rich cultural diversity of Cameroon and highlighted the importance of preserving cultural heritage for future generations.",
    date: "Apr 03, 2022",
    image: announcement5,
    readTime: "2 min read"
  },
  {
    id: 6,
    category: "Event",
    title: "A big reception for the Chairman of the Board of Directors of Adam Holding Union by His Majesty the King of Babongo and the Royal Family in Yaoundé",
    description: "It is about the reception of the Chairman of the Board of Directors of Adam Holding Union by the King of Babongo and the Royal Family in Yaoundé. This grand reception is a special event organised to highlight the role of the Chairman and the importance of Adam Holding Union in fostering economic development and cultural exchange between nations.",
    date: "Apr 03, 2022",
    image: announcement6,
    readTime: "2 min read"
  },
  {
    id: 7,
    category: "Event",
    title: "Meeting with Cameroonian Business People: New Business Cooperations Under the Leadership of Adam Holding Union President",
    description: "The Chairman of the Board of Directors of Adam Holding Union met with important representatives of the business world in Cameroon in Yaoundé. The aim of the meeting was to evaluate mutual economic opportunities, strengthen cooperation opportunities and take steps to support development projects in the region. This meeting is a bridge between both the local and international business world.",
    date: "May 29, 2022",
    image: announcement7,
    readTime: "3 min read"
  },
  {
    id: 8,
    category: "Event",
    title: "Meeting with the board of Directors, Executives, and members of Adam Holding Union",
    description: "The meeting was held in Istanbul with the board of directors, executives, and members of Adam Holding Union. The aim of the meeting was to evaluate mutual economic opportunities, strengthen cooperation opportunities and take steps to support development projects in the region. This meeting is a bridge between both the local and international business world.",
    date: "Mar 18, 2025",
    image: announcement8,
    readTime: "2 min read"
  },

{
  id: 10,
  category: "Event",
  title: "Acceptance of African Members into Adam Holding Union",
  description: "On February 13, 2026, Adam Holding Union officially welcomed new members from various African countries into the organization. This important step reflects the Union’s commitment to international cooperation, diversity, and expanding its network across the African continent. The membership acceptance ceremony emphasized unity, shared vision, and long-term strategic collaboration.",
  date: "Feb 13, 2026",
  image: announcement10,
  readTime: "2 min read"
},

{
  id: 12,
  category: "Event",
  title: "Cooperation Agreement Meeting with Hyper Company",
  description: "On January 24, 2026, Adam Holding Union organized a formal agreement meeting with Hyper Company to explore new business cooperation opportunities. The discussions emphasized innovation, strategic expansion, and the development of mutually beneficial projects. This meeting represents an important step toward strengthening corporate partnerships and expanding Adam Holding Union’s business network.",
  date: "Jan 24, 2026",
  image: announcement12,
  readTime: "2 min read"
},
{
  id: 13,
  category: "Event",
  title: "Official Appointment of King Zofoa Abubakar as Secretary General of the North West House of Chiefs, Cameroon",
  description: "On January 20, 2026, King Zofoa Abubakar was officially appointed by the President of Cameroon to the position of Secretary General of the North West House of Chiefs, Cameroon. This prestigious appointment reflects his leadership, dedication, and continued commitment to traditional governance and regional development. Adam Holding Union extends its congratulations and recognizes the importance of this milestone for institutional cooperation and cultural leadership in Cameroon.",
  date: "Jan 20, 2026",
  image: announcement13,
  readTime: "2 min read"
}
];

const categories = ["All", "Event", "Partnership", "Expansion", "Award"];

const AnnouncementsPage = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const filteredAnnouncements = announcementsData.filter(
    (announcement) => activeFilter === "All" || announcement.category === activeFilter
  );

  const handleReadMore = (announcement) => {
    setSelectedAnnouncement(announcement);
    setIsModalOpen(true);
    // Sayfa kaydırmayı engelle
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedAnnouncement(null);
    // Sayfa kaydırmayı geri aç
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="announcements-page">
      {/* Hero Section */}
      <header className="announcements-hero">
        <div className="announcements-hero-content">
          <h1 className="announcements-hero-title">📢 Announcements</h1>
          <p className="announcements-hero-subtitle">
            Stay updated with our latest news, events, and important updates from Adam Holding Union.
          </p>
        </div>
      </header>

      {/* Filter Section */}
      <section className="announcements-filters">
        <div className="announcements-filters-container">
          <h2 className="announcements-filters-title">Filter by Category</h2>
          <div className="announcements-filter-buttons">
            {categories.map((category) => (
              <button
                key={category}
                className={`announcements-filter-button ${activeFilter === category ? 'announcements-filter-button--active' : ''}`}
                onClick={() => setActiveFilter(category)}
              >
                {category}
                {category !== "All" && (
                  <span className="announcements-filter-count">
                    {announcementsData.filter(a => a.category === category).length}
                  </span>
                )}
              </button>
            ))}
          </div>
          <div className="announcements-results">
            Showing {filteredAnnouncements.length} of {announcementsData.length} announcements
          </div>
        </div>
      </section>

      {/* Announcements Grid */}
      <section className="announcements-grid-section">
        <div className="announcements-grid">
          {filteredAnnouncements.map((announcement) => (
            <article key={announcement.id} className="announcement-card">
              <div className="announcement-card-image">
                <img src={announcement.image} alt={announcement.title} />
                <div className="announcement-card-badge">
                  <span className="announcement-card-category">{announcement.category}</span>
                  <span className="announcement-card-date">{announcement.date}</span>
                </div>
                <div className="announcement-card-overlay">
                  <span className="announcement-card-readtime">{announcement.readTime}</span>
                </div>
              </div>
              <div className="announcement-card-content">
                {/* SADECE BAŞLIK GÖSTERİLİYOR */}
                <h3 className="announcement-card-title">{announcement.title}</h3>
                
                {/* AÇIKLAMA GÖSTERİLMİYOR - MODAL'DA GÖSTERİLECEK */}
                <div className="announcement-card-footer">
                  <button 
                    className="announcement-card-button"
                    onClick={() => handleReadMore(announcement)}
                  >
                    Read More
                    <span className="announcement-card-arrow">→</span>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Modal */}
      {selectedAnnouncement && (
        <AnnouncementModal
          announcement={selectedAnnouncement}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}

      {/* CTA Section */}
      <section className="announcements-cta">
        <div className="announcements-cta-content">
          <h2 className="announcements-cta-title">Never Miss an Update</h2>
          <p className="announcements-cta-text">
            Subscribe to our newsletter to get the latest announcements directly in your inbox.
          </p>
          <div className="announcements-cta-form">
            <input 
              type="email" 
              placeholder="Enter your email address"
              className="announcements-cta-input"
            />
            <button className="announcements-cta-button">Subscribe</button>
          </div>
          <p className="announcements-cta-note">
            By subscribing, you agree to our Privacy Policy and consent to receive updates.
          </p>
        </div>
      </section>
    </div>
  );
};

export default AnnouncementsPage;